var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"impressie"},[_c('Gallery')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }